export const omit = (keys: any[], obj: any) => {
    return keys.reduce((a, e) => {
        const { [e]: omit, ...rest } = a
        return rest
    }, obj)
}

// // helpers/omit.ts
// export const omit = <T extends object, K extends keyof T>(keys: K[], obj: T): Omit<T, K> => {
//     return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key as K))) as Omit<T, K>
// }
